import { basePath } from '@/next.config'
import logger from '../utils/logger'

export const clientDownloadSoundEffects = async (
	soundEffect: SoundEffect
): Promise<Response | undefined> => {
	let url
	try {
		const { downloadUrl, filename } = soundEffect
		url = `${basePath}/api/musicapp/sound-effects/downloads?fileUrl=${encodeURIComponent(
			downloadUrl
		)}&fileName=${encodeURIComponent(filename)}`

		const response = await fetch(url)

		if (!response.ok) {
			throw new Error(`Failed to download sound effect: ${response.status}`)
		}

		return response
	} catch (error) {
		logger('Error downloading sound effect', error, {
			errorType: 'Sound Effect Download',
			fetchUrl: url,
		})
	}
}
